import {
    FETCH_POINT_OF_INTEREST_IMAGES,
    FETCH_POINT_OF_INTEREST_IMAGES_FAILURE,
    FETCH_POINT_OF_INTEREST_IMAGES_SUCCESS,
} from 'store/actions/types';

export const fetchPointOfInterestImages = (payload) => {
    return {
        type: FETCH_POINT_OF_INTEREST_IMAGES,
        payload: payload,
    };
};

export const fetchPointOfInterestImagesFailure = (error) => {
    return {
        type: FETCH_POINT_OF_INTEREST_IMAGES_FAILURE,
        error: error,
    };
};

export const fetchPointOfInterestImagesSuccess = (payload, response) => {
    return {
        type: FETCH_POINT_OF_INTEREST_IMAGES_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/pointsofinterest/images/fetchPointsOfInterestImages.js